import EventSource from "./EventSource";

const _has = Object.prototype.hasOwnProperty;

const forEach = function(items, func, ctx, source) {
    if (!items) {
        return;
    }

    for (const key in items) {
        if (_has.call(items, key)) {
            func.call(ctx, items[key], key, source);
        }
    }
};

const pick = function(container, key) {
    const item = container._keyed[key];
    const indexed = container._indexed;
    return (item !== void 0 && indexed.length > item.index && indexed[item.index] === item) ? item : null;
};

const setKeyValue = function(value, key) {
    this.set(key, value);
};

const Container = function(obj) {
    EventSource.call(this);

    this._keyed = {};
    this._indexed = [];

    if (obj instanceof Container) {
        obj.forEach(setKeyValue, this);
    } else if (obj) {
        forEach(obj, setKeyValue, this);
    }
};

Container.prototype = new EventSource();

Container.prototype.forEach = function(func, ctx) {
    const indexed = this._indexed;
    for (let i = 0, len = indexed.length; i < len; i++) {
        const item = indexed[i];
        func.call(ctx, item.value, item.key, this);
    }
};

Container.prototype.valueOf = function() {
    const result = {};
    this.forEach(function(value, key) {
        if (value && typeof value === "object") {
            value = value.valueOf();
        }
        result[key] = value;
    });
    return result;
};

Container.prototype.count = function() {
    return this._indexed.length;
};

Container.prototype.set = function(key, value) {
    let item = pick(this, key);
    if (item !== null) {
        const old = item.value;
        item.value = value;
        this.trigger("updated", old, value, key);
    } else {
        const indexed = this._indexed;
        item = {
            "key": key,
            "value": value,
            "index": indexed.length
        };
        this._keyed[key] = item;
        indexed.push(item);
        this.trigger("added", value, key);
    }
};

Container.prototype.get = function(key, _default) {
    const item = pick(this, key);
    if (item !== null) {
        return item.value;
    }
    return arguments.length < 2 ? null : _default;
};

Container.prototype.pop = function(key, _default) {
    const item = pick(this, key);
    if (item === null) {
        return arguments.length < 2 ? null : _default;
    }

    delete this._keyed[key];

    const indexed = this._indexed;
    const last = indexed.pop();
    if (last !== item) {
        last.index = item.index;
        indexed[item.index] = last;
    }

    const value = item.value;
    this.trigger("removed", value, key);
    return value;
};

Container.prototype.clear = function() {
    const indexed = this._indexed;

    this._keyed = {};
    this._indexed = [];

    for (let i = 0, len = indexed.length; i < len; i++) {
        const item = indexed[i];
        this.trigger("removed", item.value, item.key);
    }
};

Container.prototype.contains = function(key) {
    return pick(this, key) !== null;
};

Container.prototype.keys = function() {
    const keys = [];
    this.forEach(function(_, key) {
        keys.push(key);
    });
    return keys;
};

Container.prototype.values = function() {
    const values = [];
    this.forEach(function(value) {
        values.push(value);
    });
    return values;
};

Container.prototype.equals = function(other) {
    if (!(other instanceof Container)) {
        return false;
    }

    if (other.count() !== this.count()) {
        return false;
    }

    const indexed = this._indexed;
    for (let i = 0, len = indexed.length; i < len; i++) {
        const item = indexed[i];
        const key = item.key;
        const value = item.value;

        if (value !== other.get(key, !value)) {
            return false;
        }
    }
    return true;
};


Container.get = function(items, key, _default) {
    if (!items || !_has.call(items, key)) {
        return arguments.length < 3 ? null : _default;
    }
    return items[key];
};

Container.pop = function(items, key, _default) {
    if (!items || !_has.call(items, key)) {
        return arguments.length < 2 ? null : _default;
    }

    const value = items[key];
    delete items[key];
    return value;
};

Container.clear = function(items) {
    forEach(items, function(_, key) {
        delete items[key];
    });
};

Container.contains = function(items, key) {
    return items && _has.call(items, key);
};

Container.forEach = function(items, func, ctx) {
    forEach(items, func, ctx, items);
};

Container.keys = function(items) {
    const keys = [];
    forEach(items, function(_, key) {
        keys.push(key);
    });
    return keys;
};

Container.values = function(items) {
    const values = [];
    forEach(items, function(value) {
        values.push(value);
    });
    return values;
};

export default Container;



// WEBPACK FOOTER //
// ./src/abusesa-js/Container.js